import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class ChannelCommonSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    this.configurations = [];
    this.original = true;
    const simpleFields = [
      "id",
      "name",
      "original",
      "maxSignalCount",
      "hasVariableIsoline",
      "hasNullableData",
      "unit",
      "defaultConfiguration",
      "currConfiguration",
      "defaultFreq"
    ];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (simpleFields.includes(key)) {
        this[key] = settings[key];
      } else if (key == "configurations") {
        this.configurations = VisualizatorSettings.copySettingsArray(settings.configurations);
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
    if (this.defaultConfiguration === undefined) {
      this.defaultConfiguration = this.currConfiguration;
    } else if (this.currConfiguration === undefined) {
      this.currConfiguration = this.defaultConfiguration;
    }
  }

  copy() {
    return new ChannelCommonSettings(this);
  }
}
